import Icon from '../components/Icon.vue'

Icon.register({
  hiking: {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M81 472.2l34.6-138.2 52.8 52.8-25.2 101c-3.6 14.5-16.7 24.2-31 24.2-2.6 0-5.2-0.3-7.8-1-17.1-4.3-27.6-21.7-23.3-38.8zM95.8 276.1c-2.2 8.4-11.1 13.5-19.9 11.4l-63.6-15.3c-8.8-2.1-14.1-10.6-11.9-19.1l25.3-98.1c11-42.1 55.4-67.7 99.3-57.2 8.8 2.1 14.1 10.6 11.9 19.1zM368 160c8.8 0 16 7.2 16 16v320c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-240h-48c-8.5 0-16.6-3.4-22.6-9.4l-22.4-22.4-19.9 79.6c-0.1 0.5-0.5 0.9-0.6 1.4l46.8 46.8c12.1 12.1 18.8 28.2 18.8 45.3v82.8c0 17.7-14.3 32-32 32s-32-14.3-32-32v-82.8l-86.6-86.6c-5.2-5.2-9.4-15.3-9.4-22.6 0-2.2 0.4-5.6 1-7.8l26.9-107.7c6.6-26.2 30-44.5 57-44.5 15.7 0 30.5 6.1 41.6 17.2l46.8 46.8h34.8v-16c0-8.8 7.2-16 16-16h16zM240 96c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48z'
      }
    ]
  }
})
